import React from "react";
import { Link } from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaWhatsapp,
} from "react-icons/fa";

import footerData from "../../data/footerData";
import useWebsiteSettings from "../../hooks/useWebsiteSettings";

import "./Footer.css";

const Footer = () => {
  const { settings } = useWebsiteSettings();

  // Use Firebase settings first.
  // If a field is empty, fall back to footerData.
  const companyName = settings.companyName || "Quality Sports Surface";

  const phone = settings.phone || footerData.phone;
  const email = settings.email || footerData.email;
  const address = settings.address || footerData.address;

  const instagram = settings.instagram || "#";
  const facebook = settings.facebook || "#";
  const youtube = settings.youtube || "#";

  // LinkedIn is not currently in our Firebase settings,
  // so keep using the existing footerData value if available.
  // const linkedin = footerData.linkedin || "#";
  const linkedin = settings.linkedin || "#";
  const whatsappNumber = settings.whatsapp
    ? settings.whatsapp.replace(/\D/g, "")
    : "";

  const whatsappLink = whatsappNumber ? `https://wa.me/${whatsappNumber}` : "#";

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* ====================================
                COMPANY
        ==================================== */}

        <div className="footer-about">
          <img
            src={footerData.logo}
            alt={companyName}
            className="footer-logo"
          />

          <p>{footerData.description}</p>

          <div className="footer-social">
            <a
              href={facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href={instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

            <a
              href={youtube}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* ====================================
                QUICK LINKS
        ==================================== */}

        <div className="footer-links">
          <h3>Quick Links</h3>

          <ul>
            {footerData.links.map((item, index) => (
              <li key={index}>
                <Link to={item.link}>{item.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* ====================================
                SERVICES
        ==================================== */}

        {/* <div className="footer-links">

          <h3>Our Services</h3>

          <ul>

            {footerData.services.map((item, index) => (
              <li key={index}>

                <Link to="/">
                  {item}
                </Link>

              </li>
            ))}

          </ul>

        </div> */}

        <div className="footer-links-column">
          <h3>Our Services</h3>

          {footerData.services.map((service) => (
            <Link key={service.link} to={service.link} className="footer-link">
              {service.title}
            </Link>
          ))}
        </div>

        {/* ====================================
                CONTACT
        ==================================== */}

        <div className="footer-contact">
          <h3>Contact Us</h3>

          {/* ADDRESS */}

          <div className="contact-item">
            <FaMapMarkerAlt />

            <span>{address || "Address not available"}</span>
          </div>

          {/* PHONE */}

          <div className="contact-item">
            <FaPhoneAlt />

            {phone ? (
              <a href={`tel:${phone}`} className="footer-contact-link">
                {phone}
              </a>
            ) : (
              <span>Phone not available</span>
            )}
          </div>

          {/* EMAIL */}

          <div className="contact-item">
            <FaEnvelope />

            {email ? (
              <a href={`mailto:${email}`} className="footer-contact-link">
                {email}
              </a>
            ) : (
              <span>Email not available</span>
            )}
          </div>

          {/* WHATSAPP */}

          {whatsappNumber && (
            <div className="contact-item">
              <FaWhatsapp />

              <span className="whatsapp-footer-icon">WhatsApp</span>

              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                Chat with us
              </a>
            </div>
          )}

          {/* TIMING */}

          <div className="contact-item">
            <FaClock />

            <span>{footerData.timing}</span>
          </div>
        </div>
      </div>

      {/* ====================================
              COPYRIGHT
      ==================================== */}

      <div className="footer-bottom">
        <p>© 2026 {companyName}. All Rights Reserved.</p>

        <div className="footer-bottom-links">
          <Link to="/privacy">Privacy Policy</Link>

          <Link to="/terms">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
